import React from "react";
import ManagerMain from "../../components/manager/pages/ManagerMain";
import { LanguageContext } from "../../context/LanguageContext.jsx";
import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../context/LoginContext";
// import useFetch from "../../hook/useFetch";

export default function Manager() {
  const { language } = useContext(LanguageContext);
  const { user } = useAuth();
  return (
    <>
      <ManagerMain language={language} user={user} />
      <Outlet />
    </>
  );
}
